export function capitalize(value: string) {
  if (!value) return '';

  let capitalizedText = '';
  const conjunctions = [
    'an',
    'a',
    'the',
    'of',
    'and',
    'but',
    'for',
    'nor',
    'or',
    'so',
    'yet',
    'in',
    'on',
    'at',
    'to',
    'by',
    'with',
  ];

  // NEW FEATURE: Replace underscores with spaces before processing
  const cleanValue = value.replace(/_/g, ' ');

  const textArray = cleanValue.split(' ').filter(Boolean); // remove empty spaces

  for (let i = 0; i < textArray.length; i++) {
    const word = textArray[i];
    const lower = word.toLowerCase();

    if (i === 0 || word.endsWith('.')) {
      // Always capitalize first word or sentence after a period
      capitalizedText +=
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + ' ';
    } else if (conjunctions.includes(lower)) {
      // Keep conjunctions lowercase
      capitalizedText += lower + ' ';
    } else {
      // Capitalize all other words
      capitalizedText +=
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + ' ';
    }
  }

  return capitalizedText.trim();
}
